export default __webpack_public_path__ + "static/media/P314 zu P207.65f8ebbf.mp3";